import { DisablePayment } from 'types/disablePayment';
import { ApiClients } from '../../utils/axios';
import { getDisablePaymentSuccess, hasError, startLoading } from '../slices/disablePayment';
import { dispatch } from '../store';

const { axiosBase } = ApiClients;

export function getDisablePaymentThunk() {
  return async () => {
    dispatch(startLoading());
    try {
      const response = await axiosBase.get<DisablePayment>('g-trusted');

      dispatch(getDisablePaymentSuccess(response.data));

      return response.data.data;
    } catch (error) {
      dispatch(hasError(error));

      throw new Error(error);
    }
  };
}

export function editDisablePaymentThunk(params: DisablePayment) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosBase.put('g-trusted', {
        ...params.data,
      });

      return true;
    } catch (error) {
      dispatch(hasError(error));

      throw new Error(error);
    }
  };
}
